import { render, staticRenderFns } from "./course-drawer.vue?vue&type=template&id=4e537ec9&"
import script from "./course-drawer.vue?vue&type=script&lang=js&"
export * from "./course-drawer.vue?vue&type=script&lang=js&"
import style0 from "./course-drawer.vue?vue&type=style&index=0&id=4e537ec9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports